import axios from 'axios'
import { normalize, schema } from 'normalizr'
import CreateReducer from '../utils/createReducer'
import CreateActions from '../utils/createActions'
import { mergeEntities, mergeAll } from '../utils/mergeNormalized'
import networkWrapper from '../utils/networkWrapper'
import api from '../api'

import selectors from '../selectors'
import snackbarActions from './snackbar'
import routerActions from './router'
import userActions from './user'

const project = new schema.Entity('project')

const prefix = 'project'

const initialState = {
  projects: normalize([], [project]),
  queryProjectId: '',
}

const reducers = {
  setProjects: (state, action) => {
    state.projects = normalize(action.payload, [project])
  },
  setProject: (state, action) => {
    mergeEntities(state.projects, normalize([action.payload], [project]))
  },
  setQueryProjectId: (state, action) => {
    state.queryProjectId = action.payload
  },
}

const loaders = {

  list: () => axios.get(api.url('/projects'))
    .then(api.process),

  get: (id) => axios.get(api.url(`/projects/${id}`))
    .then(api.process),

  create: (data) => axios.post(api.url(`/projects`), data)
    .then(api.process),

  save: (id, data) => axios.put(api.url(`/projects/${id}`), data)
    .then(api.process),

  delete: (id) => axios.delete(api.url(`/projects/${id}`))
    .then(api.process),

}

const sideEffects = {
  list: () => networkWrapper({
    prefix,
    name: 'list',
    handler: async (dispatch, getState) => {
      const data = await loaders.list()
      dispatch(actions.setProjects(data))
    },
    errorHandler: (dispatch, getState, errorMessage) => {
      dispatch(snackbarActions.setError(`there was an error listing the projects: ${errorMessage}`))
    }
  }),

  get: (id) => networkWrapper({
    prefix,
    name: 'get',
    handler: async (dispatch, getState) => {
      if(id == 'new') return
      const data = await loaders.get(id)
      dispatch(actions.setProject(data))
    },
    errorHandler: (dispatch, getState, errorMessage) => {
      dispatch(snackbarActions.setError(`there was an error getting the project: ${errorMessage}`))
    }
  }),

  save: (id, data) => networkWrapper({
    prefix,
    name: 'save',
    handler: async (dispatch, getState) => {
      const loader = id == 'new' ?
        () => loaders.create(data) :
        () => loaders.save(id, {
          name: data.name,
          meta: data.meta,
        })
      await loader()
      await dispatch(userActions.loadStatus())
      dispatch(snackbarActions.setSuccess(`project ${ id == 'new' ? 'created' : 'saved' }`))
      dispatch(routerActions.navigateTo('project.list'))
    },
    errorHandler: (dispatch, getState, errorMessage) => {
      dispatch(snackbarActions.setError(`there was an error saving the project: ${errorMessage}`))
    }
  }),

  delete: (id) => networkWrapper({
    prefix,
    name: 'delete',
    handler: async (dispatch, getState) => {
      await loaders.delete(id)
      dispatch(snackbarActions.setInfo(`project deleted`))
      dispatch(actions.list())
    },
    errorHandler: (dispatch, getState, errorMessage) => {
      dispatch(snackbarActions.setError(`there was an error deleting the project: ${errorMessage}`))
    }
  }),

  setActiveProject: (id) => networkWrapper({
    prefix,
    name: 'setActiveProject',
    handler: async (dispatch, getState) => {
      const project = selectors.project.collection.get(getState(), id)
      await dispatch(userActions.updateMeta({
        activeProject: id,
      }))
      dispatch(snackbarActions.setSuccess(`${project.name} project activated`))
      dispatch(routerActions.navigateTo('project.list'))
    },
    errorHandler: (dispatch, getState, errorMessage) => {
      dispatch(snackbarActions.setError(`there was an error updating the active project: ${errorMessage}`))
    }
  }),

}

const reducer = CreateReducer({
  initialState,
  reducers,
  prefix,
})

const actions = CreateActions({
  reducers,
  sideEffects,
  prefix,
})

export {
  actions,
  reducer,
}

export default actions